import React from "react";
import "./bodyEight.scss";

export function BodyEight() {
  return (
    <section className="wrapper_section_eight">
      <div className="contact1">
        <p className="secondaryColor">Contacto general:</p>
        <a href="mailto:comunicacion@hospitalescruzazul.com.mx" className="thirdColor">comunicacion@hospitalescruzazul.com.mx</a>
      </div>
      <div className="contact2">
        <p className="secondaryColor">Quejas y sugerencias:</p>
        <a href="mailto:buzondequejas@hospitalescruzazul.com.mx" className="thirdColor">buzondequejas@hospitalescruzazul.com.mx</a>
      </div>
    </section>
  );
}
